export default function * success ({ res, fileType }) {
  console.log(res, fileType)
  const blob = new Blob([res.data], { type: res.headers['content-type'] })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  if(fileType === 'pdf'){
    link.download = `${res.config.url.split('/')[2]}.pdf`
  }
  else if(fileType === 'excel'){
    link.download = `${res.config.url.split('/')[2]}.xlsx`
  }
  document.body.appendChild(link)
  link.click()
  link.remove()
}
